var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconHomeDollar(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M10.281 14.624h-.505v-.699c-1.235-.07-2.131-.716-2.162-1.815H8.79c.07.449.387.76.985.827v-1.604l-.295-.07c-1.147-.26-1.78-.774-1.78-1.723 0-1.05.866-1.732 2.075-1.807v-.712h.505v.717c1.222.088 2.013.773 2.057 1.81h-1.173c-.062-.474-.392-.747-.884-.817v1.551l.312.066c1.2.273 1.828.756 1.828 1.718 0 1.103-.892 1.771-2.14 1.855v.703zm-.505-5.902c-.554.066-.844.352-.844.703 0 .352.25.58.844.739V8.722zm.505 4.215c.611-.062.914-.335.914-.734 0-.387-.233-.585-.914-.756v1.49z", clipRule: "evenodd" }),
        React.createElement("path", { fillRule: "evenodd", d: "M10.49 1.433a.75.75 0 00-.98 0l-7 6.058a.75.75 0 00-.26.567V17c0 .414.336.75.75.75h14a.75.75 0 00.75-.75V8.058a.75.75 0 00-.26-.567l-7-6.058zM3.75 16.25V8.4L10 2.992 16.25 8.4v7.85H3.75z", clipRule: "evenodd" })));
}
export default IconHomeDollar;
